<template>
  <cv-button
    class="filter-tag-button"
    :kind="kind"
    :size="size"
    :icon-only="iconOnly"
    :disabled="disabled"
    :class="cssClasses"
    @click="handleFilterClick"
  >
    <svg-icon class="filter-icon" name="Filter24" kind="action" />

    <div v-if="showLabel" class="label">{{ t("filter_title_label") }}</div>

    <div v-if="hasActiveFilters" class="filter-count" @click.stop.prevent="handleRemoveFilters">
      <span> {{ filterCount }} </span>
      <svg-icon class="remove" name="CrossTag16" kind="action" />
    </div>
  </cv-button>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";

// Props
interface Props {
  kind?: string;
  size?: string;
  iconOnly?: boolean;
  disabled?: boolean;
  filterCount?: number;
}

const {
  kind = "tertiary",
  size = "medium",
  iconOnly = false,
  disabled = false,
  filterCount = 0,
} = defineProps<Props>();

// Emits
const emit = defineEmits<{
  click: [];
  remove: [];
}>();

const { t } = useI18n();

// Computed
const cssClasses = computed(() => {
  return {
    "icon-only": iconOnly,
  };
});

const hasActiveFilters = computed(() => {
  return filterCount > 0;
});

const showLabel = computed(() => {
  return !iconOnly;
});

// Methods
const handleFilterClick = () => {
  emit("click");
};

const handleRemoveFilters = () => {
  emit("remove");
};
</script>

<style lang="scss">
@import "@styles/themes/sls-theme/tokens/colors";
@import "@styles/themes/sls-theme/tokens/spacing";
@import "@styles/themes/sls-theme/tokens/typo";

.filter-tag-button {
  min-width: inherit;
  // Max-height to prevent the button from jumping in size changes when there is an active filter
  max-height: 40px;

  &.icon-only {
    .sls-icon {
      margin-right: 0;
    }
  }

  .filter-count {
    @include carbon--type-style("helper-text-01");
    display: flex;
    align-items: center;
    margin-left: $spacing-03;
    padding: $spacing-02 $spacing-03;
    color: $text-04;
    background-color: $interactive-02;
    border-radius: 12px;

    .sls-icon {
      margin: 0 0 0 0.375rem;
    }
  }
}
</style>
